//--------------------------------------------------
// imported classes
//--------------------------------------------------
const BaseMediator = require('@/tbs/controller/BaseMediator')
const ClassFunc = require('@/tbs/util/ClassFunc')
const ObjectFunc = require('@/tbs/util/ObjectFunc')
const MatchStaff = require('@/tbs/model/vo/MatchStaff')
const DataConvertor = require('@/tbs/core/DataConvertor')
// const ModelLocator = require('@/tbs/model/ModelLocator')

/**
 * The MatchMediator class maintains the business logic
 * for the organization.
 */
const tbs_controller_StaffMediator = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, BaseMediator, arguments)
    // console.log('tbs_controller_StaffMediator constructor')
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_controller_StaffMediator.prototype = {
    //--------------------------------------------------
    // api method
    //--------------------------------------------------
    /**
     * @api
     * Handle the creation complete condition triggered by 
     * the scene instance.
     */
    handleCreationComplete: function() {
        // console.log('handleCreationComplete')
        const organizationId = this._bridge.getRouteQuery('organizationId')
        if (!this._bridge.isCreate()) {
            if (this._bridge.isList()) {
                this.creationComplete({parameters: {accountId: organizationId}})
            }
            else {
                this.creationComplete()
            }
        }
        else {
            this.target().matchId = this._bridge.getRouteQuery('matchId')
        }
        if (this._bridge.isList()) {
            // set the organization id via the route query
            this.target().organizationId = organizationId
        }
        else {
            this.target().staff.organizationId = organizationId
        }
        console.log('@handleCreationComplete', this._bridge.isDetail(), this._bridge.getRouteQuery('isMatchOperator') == 'true', this._bridge.getRouteQuery('isMatchOperator'))
        if (this._bridge.isDetail() && this._bridge.getRouteQuery('isMatchOperator') == 'true') {
            this.loadMatchStaff(this._bridge.getRouteParam('id'), organizationId)
        }
    },
    /**
     * @api
     * Handle the custom event condition triggered by 
     * the scene instance.
     * @event The event object contains 
     * {type:String, data:Object, target:VueComponent}
     */
    handleCustomEvent: function(event) {
        console.log('handleCustomEvent', event)
        if (event.type == 'save') {
            this.submitData(event.target, event.data, true)
        }
        else if (event.type == 'submit') {
            this.submitData(event.target, event.data)
        }
        else if (event.type == 'delete') {
            this.deleteRecord(event.target, event.data)
        }
        else if (event.type == 'navigate') {
            this._bridge.goToScene(event.data.name, event.data.params, ObjectFunc.mergeObject(event.data.query, this._bridge.getRouteQuery()))
        }
        /*else if (event.type == 'tab') {
            this.creationComplete({parameters: event.data.parameters})
        }*/
        else if (event.type == 'grant') {
            this.addMatchStaffRelation(event.data)
        }
        else if (event.type == 'revoke') {
            this.deleteMatchStaffRelation(event.data)
        }
        else if (event.type == 'invite') {
            this.sendStaffInvite(event.data)
        }
    },
    handleRouteBack: function() {
        if (this._bridge.getRouteName() == 'OrgListStaff') {
            this._bridge.goToScene('OrgManageOrganization', {id: this._bridge.getRouteQuery('organizationId')})
        }
        else {
            this._bridge.back()
        }
    },
    handleRemoveService: function() {
        const from = this._bridge.getRouteQuery('from')
        if (from == 'OrgListMatchStaff') {
            this._bridge.goToScene(from, {id: this._bridge.getRouteQuery('matchId')}, {organizationId: this.target().staff.organizationId})
        }
        else {
            this._bridge.goToScene('OrgListStaff', {}, {organizationId: this.target().staff.organizationId})
        }
    },
    handleCreateService: function(e) {
        console.log('handleCreateService', e)
        // validate the query matchId
        const matchId = this._bridge.getRouteQuery('matchId')
        if (matchId) {
            this.addMatchStaffRelation({
                staffId: e.data.payload.data.id,
                matchId: matchId,
                from: 'match'
            })
        }
        else {
            this._bridge.back()
        }
    },
    deleteMatchStaffRelation: function(data) {
        console.log('deleteMatchStaffRelation', data)
        const self = this
        const matchStaff = new MatchStaff
        const source = matchStaff.view.remove
        const service = 'removeMatchStaffRelation'
        const postBody = DataConvertor.transform(matchStaff, data, 'remove')
        self._bridge.addResourceListener(service, function(e) {
            self._bridge.removeResourceListener(service, e.handler)
            console.log('remove.data', service, e.data)
            // update the match staff list
            self.handleCreationComplete()
        })
        self._bridge.callResourceInstance(service, {
            baseUrl: source.baseUrl,
            apiPrefix: source.apiPrefix,
            apiSuffix: source.apiSuffix,
            serviceName: source.service,
            method: 'POST',
            data: postBody
        })
    },
    addMatchStaffRelation: function(data) {
        console.log('addMatchStaffRelation', data)
        const self = this
        const matchStaff = new MatchStaff
        const source = matchStaff.view.create
        const service = 'createMatchStaffRelation'
        const postBody = DataConvertor.transform(matchStaff, data, 'create')
        self._bridge.addResourceListener(service, function(e) {
            self._bridge.removeResourceListener(service, e.handler)
            console.log('create.data', service, e.data)
            // update the match staff list
            if (data.from == 'match') {  
                self._bridge.back()
            }
            else {
                // update the target.matchList and target.staff.matchList
                self.handleCreationComplete()
            }
        })
        self._bridge.callResourceInstance(service, {
            baseUrl: source.baseUrl,
            apiPrefix: source.apiPrefix,
            apiSuffix: source.apiSuffix,
            serviceName: source.service,
            method: 'POST',
            data: postBody
        })
    },
    loadMatchStaff: function(staffId, organizationId) {
        console.log('@loadMatchStaff', staffId, organizationId)
        const self = this
        const matchStaff = new MatchStaff
        const source = matchStaff.view.query
        const service = 'queryMatchStaff'
        const parameters = {
            orgId: organizationId,
            pageNum: 1,
            pageSize: 1000
        }
        self._bridge.addResourceListener(service, function(e) {
            self._bridge.removeResourceListener(service, e.handler)
            console.log('query.data', service, e.data)
            const matchList = DataConvertor.transform(matchStaff, e.data.payload, 'query')
            const staffMatchList = self.target().staff.matchList
            for (let i = 0; i < matchList.length; i++) {
                let match = matchList[i]
                for (let j = 0; j < staffMatchList.length; j++) {
                    let staffMatch = staffMatchList[j]
                    if (match.matchId == staffMatch.matchId) {
                        match.staffId = staffId
                        break
                    }
                }
            }
            console.log('@staff match list', staffMatchList, matchList)
            self.target().matchList = matchList
        })
        self._bridge.callResourceInstance(service, {
            baseUrl: source.baseUrl,
            apiPrefix: source.apiPrefix,
            apiSuffix: source.apiSuffix,
            serviceName: source.service,
            method: 'GET',
            parameters: parameters
        })
    }
}

//--------------------------------------------------
// extends the BaseMediator
//--------------------------------------------------
ClassFunc.extend(tbs_controller_StaffMediator, BaseMediator);

module.exports = tbs_controller_StaffMediator